import { render, staticRenderFns } from "./CandidateDetails.vue?vue&type=template&id=49991aec&scoped=true"
import script from "./CandidateDetails.vue?vue&type=script&lang=js"
export * from "./CandidateDetails.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetails.vue?vue&type=style&index=0&id=49991aec&prod&lang=scss&scoped=true"
import style1 from "./CandidateDetails.vue?vue&type=style&index=1&id=49991aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49991aec",
  null
  
)

export default component.exports